import { Action, Reducer } from 'redux';
import { fork, call, takeEvery, put } from 'redux-saga/effects';

import Api from '../api';

import { actionCreators as layoutActionCreators } from '../reducers/Layout';

import { IRootState } from './index';

import TaskModel from '../models/Task';
import Task from '../models/Task';

// Store
export interface ITaskState {
    loading: boolean;
    tasks: TaskModel[];
}

const initialState: ITaskState = {
    loading: false,
    tasks: [],
};

// Action Types
export enum actionTypes {
    ALL_TASKS_REQUEST = '[task] ALL_TASKS_REQUEST',
    ALL_TASKS_SUCCESS = '[task] ALL_TASKS_SUCCESS',
    ALL_TASKS_FAIL = '[task] ALL_TASKS_FAIL',
    CREATE_TASK = '[task] CREATE_TASK',
    CREATE_TASK_SUCCESS = '[task] CREATE_TASK_SUCCESS',
}

// Action Creator
export const actionCreators = {
    getTasks: () => {
        return { type: actionTypes.ALL_TASKS_REQUEST };
    },
    getTasksSuccess: (tasks: Array<TaskModel>) => {
        return { type: actionTypes.ALL_TASKS_SUCCESS, payload: tasks };
    },
    createTask: (userId: number, task: Task) => {
        return { type: actionTypes.CREATE_TASK, payload: task };
    },
    createTaskSuccess: () => {
        return { type: actionTypes.CREATE_TASK_SUCCESS };
    },
};

// Reducer
const reducer: Reducer<ITaskState> = (state: ITaskState = initialState, action: Action): ITaskState => {
    switch (action.type) {
        case actionTypes.ALL_TASKS_REQUEST: {
            return {
                ...state,
                loading: true,
                tasks: initialState.tasks,
            };
        }
        case actionTypes.ALL_TASKS_SUCCESS: {
            const payload = (action as { type: string; payload: Array<TaskModel> }).payload;
            return {
                ...state,
                loading: false,
                tasks: payload,
            };
        }
        default:
            return state;
    }
};

export default reducer;

export const selectors = {
    isLoading: (state: IRootState): boolean => state.task.loading || state.layout.initialLoading,
    tasks: (state: IRootState): TaskModel[] => state.task.tasks,
};

const sagas = {
    getTasks: function* (action: { type: string }) {
        const result: Array<TaskModel> = yield call(Api.Task.getAll);
        yield put(actionCreators.getTasksSuccess(result));
    },
    createTask: function* (action: { type: string }) {
        yield call(layoutActionCreators.waitIniitalLoadState);
    },
};

const watches = {
    getTasks: function* () {
        yield takeEvery(actionTypes.ALL_TASKS_REQUEST, sagas.getTasks);
    },
    createTask: function* () {
        yield takeEvery(actionTypes.CREATE_TASK, sagas.createTask);
    },
};

export function* saga() {
    yield fork(watches.getTasks);
    yield fork(watches.createTask);
}



// WEBPACK FOOTER //
// ./src/reducers/Task.ts